<section [ngClass]="isSmallScreen ? 'hidden' : ''"
    class="fixed !z-[999999999999] flex items-start w-screen h-screen top-0 right-0 pointer-events-none">
    <div class="absolute top-16 right-4 flex flex-col pointer-events-auto">
        <div *ngIf="showCloseButton" [@fadeButton] class="flex justify-end bg-black/4 backdrop-blur-sm rounded-lg p-4">
            <button (click)="closeAllNotifications()"
                class="flex items-center justify-center bg-mg-main-blue-dark text-white gap-1 px-2 py-1 rounded-full p-2 lg:rounded-lg">
                <mg-icon iconName="notifications_off" [iconClass]="'text-lg'"></mg-icon>
                <span class="lg:inline hidden">Cerrar</span>
            </button>
        </div>
        <div *ngIf="allToast['top-r'].length" class="flex flex-col gap-4 pointer-events-auto">
            <mg-toast-alert *ngFor="let toast of allToast['top-r']" [toastData]="toast"></mg-toast-alert>
        </div>
    </div>
</section>